// extracted by mini-css-extract-plugin
export default {"box":"bullkSparesListPage_box__17wGH"};